import { apiService } from '@/shared/services/api';
import type {
  TeamMember,
  DownlineTreeResponse,
  TrainingRequestsResponse,
  TeamSalesData,
  TeamRecruitData,
  RescheduleTrainingRequest,
  ConfirmTrainingRequest,
  MarkTrainingCompleteRequest,
} from '../types';

const BASE_URL = '/sales-manager';

export const salesManagerService = {
  // Team Sales
  async getTeamSales(filters?: {
    dateFrom?: string;
    dateTo?: string;
    campaignId?: string;
    status?: string;
  }): Promise<TeamSalesData> {
    const params = new URLSearchParams();
    if (filters?.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters?.dateTo) params.append('dateTo', filters.dateTo);
    if (filters?.campaignId) params.append('campaignId', filters.campaignId);
    if (filters?.status) params.append('status', filters.status);

    const response = await apiService.get(`${BASE_URL}/team-sales?${params.toString()}`);
    return response.data;
  },

  // Team Recruits
  async getTeamRecruits(filters?: {
    step?: number;
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<TeamRecruitData> {
    const params = new URLSearchParams();
    if (filters?.step) params.append('step', filters.step.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const response = await apiService.get(`${BASE_URL}/team-recruits?${params.toString()}`);
    return response.data;
  },

  // Downline Tree
  async getDownlineTree(depth?: number): Promise<DownlineTreeResponse> {
    const params = depth ? `?depth=${depth}` : '';
    const response = await apiService.get(`${BASE_URL}/downline-tree${params}`);
    return response.data;
  },

  // Training Requests
  async getTrainingRequests(filters?: {
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<TrainingRequestsResponse> {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const response = await apiService.get(`${BASE_URL}/training-requests?${params.toString()}`);
    return response.data;
  },

  // Reschedule Training
  async rescheduleTraining(data: RescheduleTrainingRequest): Promise<{ success: boolean; message: string }> {
    const response = await apiService.post(`${BASE_URL}/training-requests/reschedule`, data);
    return response.data;
  },

  // Confirm Training
  async confirmTraining(data: ConfirmTrainingRequest): Promise<{ success: boolean; message: string }> {
    const response = await apiService.post(`${BASE_URL}/training-requests/confirm`, data);
    return response.data;
  },

  // Mark Training Complete
  async markTrainingComplete(data: MarkTrainingCompleteRequest): Promise<{ success: boolean; message: string }> {
    const response = await apiService.post(`${BASE_URL}/training-requests/complete`, data);
    return response.data;
  },

  // Get recruit details
  async getRecruitDetails(recruitId: string): Promise<TeamMember> {
    const response = await apiService.get(`${BASE_URL}/recruits/${recruitId}`);
    return response.data;
  },
};

export default salesManagerService;
